import { useEffect } from 'react';

//This function's purpose is to scroll the elements into view
const useScrollIntoView = () => {

  useEffect(() => {
    const elementsToObserve = document.querySelectorAll('.appearOnScroll');

    const observer = new IntersectionObserver(entries => {
      
      entries.forEach(entry => {
        // Add 'animate' class when the element comes into view
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
        } else {
          // Optionally remove the 'animate' class when the element is out of view
          entry.target.classList.remove('animate');
        }
      });
    });

    // Start observing all elements with the 'appearOnScroll' class
    elementsToObserve.forEach(element => observer.observe(element));

    // Cleanup function to stop observing when the component is unmounted
    return () => {
      elementsToObserve.forEach(element => observer.unobserve(element));
    };
  }, []);  // Empty dependency array ensures this effect runs only once on mount
};

export default useScrollIntoView;
